export default "__VITE_ASSET__H9D05Qm7__"